import React, { useRef } from "react";
import { useSyncRefHeight } from "../../utils/useSyncRefHeightHook";

const BrandRuleResultRenderer = ({ index, isMilestoneView, children, expandState }) => {
  const brandRuleRef = useRef(null);

  useSyncRefHeight(
    [[`rule-${index}`, brandRuleRef]],
    // trigger hook when items of footerItems changes, since it may change height
    [index, children, expandState],
  );

  return isMilestoneView && window.innerWidth > 1100 ? (
    <div key={index} className={`form-value rule-${index}`} ref={brandRuleRef}>
      {children}
    </div>
  ) : (
    <div key={index} className="form-value">
      {children}
    </div>
  );
};

export default BrandRuleResultRenderer;
